const headers = {}

export default headers